import { render, staticRenderFns } from "./brandAndType.vue?vue&type=template&id=085210db&scoped=true"
import script from "./brandAndType.vue?vue&type=script&lang=js"
export * from "./brandAndType.vue?vue&type=script&lang=js"
import style0 from "./brandAndType.vue?vue&type=style&index=0&id=085210db&prod&lang=css"
import style1 from "./brandAndType.vue?vue&type=style&index=1&id=085210db&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "085210db",
  null
  
)

export default component.exports